const mapping = new Map([
    ['01', { ap: 'Ala.', postal: 'AL'}],
    ['02', { ap: 'Alaska', postal: 'AK'}],
    ['04', { ap: 'Ariz.', postal: 'AZ'}],
    ['05', { ap: 'Ark.', postal: 'AR'}],
    ['06', { ap: 'Calif.', postal: 'CA'}],
    ['06S', { ap: 'Calif.', postal: 'CA'}],
    ['08', { ap: 'Colo.', postal: 'CO'}],
    ['09', { ap: 'Conn.', postal: 'CT'}],
    ['10', { ap: 'Del.', postal: 'DE'}],
    ['11', { ap: 'D.C.', postal: 'DC'}],
    ['12', { ap: 'Fla.', postal: 'FL'}],
    ['13', { ap: 'Ga.', postal: 'GA'}],
    ['15', { ap: 'Hawaii', postal: 'HI'}],
    ['16', { ap: 'Idaho', postal: 'ID'}],
    ['17', { ap: 'Ill.', postal: 'IL'}],
    ['18', { ap: 'Ind.', postal: 'IN'}],
    ['18S', { ap: 'Ind.', postal: 'IN'}],
    ['19', { ap: 'Iowa', postal: 'IA'}],
    ['20', { ap: 'Kan.', postal: 'KS'}],
    ['21', { ap: 'Ky.', postal: 'KY'}],
    ['22', { ap: 'La.', postal: 'LA'}],
    ['23', { ap: 'Maine', postal: 'ME'}],
    ['24', { ap: 'Md.', postal: 'MD'}],
    ['25', { ap: 'Mass.', postal: 'MA'}],
    ['26', { ap: 'Mich.', postal: 'MI'}],
    ['27', { ap: 'Minn.', postal: 'MN'}],
    ['28', { ap: 'Miss.', postal: 'MS'}],
    ['29', { ap: 'Mo.', postal: 'MO'}],
    ['30', { ap: 'Mont.', postal: 'MT'}],
    ['31', { ap: 'Neb.', postal: 'NE'}],
    ['31S', { ap: 'Neb.', postal: 'NE'}],
    ['32', { ap: 'Nev.', postal: 'NV'}],
    ['33', { ap: 'N.H.', postal: 'NH'}],
    ['34', { ap: 'N.J.', postal: 'NJ'}],
    ['35', { ap: 'N.M.', postal: 'NM'}],
    ['36', { ap: 'N.Y.', postal: 'NY'}],
    ['37', { ap: 'N.C.', postal: 'NC'}],
    ['38', { ap: 'N.D.', postal: 'ND'}],
    ['39', { ap: 'Ohio', postal: 'OH'}],
    ['40', { ap: 'Okla.', postal: 'OK'}],
    ['40S', { ap: 'Okla.', postal: 'OK'}],
    ['41', { ap: 'Ore.', postal: 'OR'}],
    ['42', { ap: 'Pa.', postal: 'PA'}],
    ['44', { ap: 'R.I.', postal: 'RI'}],
    ['45', { ap: 'S.C.', postal: 'SC'}],
    ['46', { ap: 'S.D.', postal: 'SD'}],
    ['47', { ap: 'Tenn.', postal: 'TN'}],
    ['48', { ap: 'Texas', postal: 'TX'}],
    ['49', { ap: 'Utah', postal: 'UT'}],
    ['50', { ap: 'Vt.', postal: 'VT'}],
    ['51', { ap: 'Va.', postal: 'VA'}],
    ['53', { ap: 'Wash.', postal: 'WA'}],
    ['54', { ap: 'W.Va.', postal: 'WV'}],
    ['55', { ap: 'Wis.', postal: 'WI'}],
    ['56', { ap: 'Wyo.', postal: 'WY'}],
  ]);
  
  export default mapping;